import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import api from "@/lib/api";

const Ctx = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    try {
      const r = await api.get("/auth/customer/me");
      setUser(r.data);
    } catch { setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { check(); }, [check]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/my-bookings";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const login = async (email, password) => {
    const r = await api.post("/auth/customer/login", { email, password });
    setUser(r.data);
    return r.data;
  };

  const register = async (name, email, password) => {
    const r = await api.post("/auth/customer/register", { name, email, password });
    setUser(r.data);
    return r.data;
  };

  const forgotPassword = async (email) => {
    const r = await api.post("/auth/customer/forgot-password", { email });
    return r.data;
  };

  const resetPassword = async (token, password) => {
    const r = await api.post("/auth/customer/reset-password", { token, password });
    setUser(r.data);
    return r.data;
  };

  const signOut = async () => {
    await api.post("/auth/customer/logout").catch(() => {});
    setUser(null);
  };

  const value = useMemo(
    () => ({ user, loading, signIn, signOut, login, register, forgotPassword, resetPassword, refresh: check }),
    [user, loading, check]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useCustomer = () => useContext(Ctx);
